module.exports = __webpack_public_path__ + "static/media/2024-07-10-01.fd9b84c0.jpg";